import React, { createContext, useContext } from 'react';
import { MoodleUiConfig, MoodleUiContextValue } from './types';

const MoodleUiContext = createContext<MoodleUiContextValue | null>(null);

interface Props {
  config: MoodleUiConfig;
  children: React.ReactNode;
}

export function MoodleUiProvider({ config, children }: Props) {
  return (
    <MoodleUiContext.Provider value={{ config }}>
      {children}
    </MoodleUiContext.Provider>
  );
}

export function useMoodleUi() {
  const ctx = useContext(MoodleUiContext);
  if (!ctx) {
    throw new Error('useMoodleUi must be used within MoodleUiProvider');
  }
  return ctx;
}